module.exports = __webpack_public_path__ + "static/img/couponBg7704e8e.png";